class FlixHero extends HTMLElement {
  connectedCallback() {
    this._section = this.querySelector('section');
    if (!this._section) return;
    this._onMove = this._onMove.bind(this);
    this._onLeave = this._onLeave.bind(this);
    this._section.addEventListener('mousemove', this._onMove);
    this._section.addEventListener('mouseleave', this._onLeave);
  }

  disconnectedCallback() {
    if (!this._section) return;
    this._section.removeEventListener('mousemove', this._onMove);
    this._section.removeEventListener('mouseleave', this._onLeave);
  }

  _onMove(e) {
    const r = this._section.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - 0.5;
    const y = (e.clientY - r.top) / r.height - 0.5;
    this._section.querySelectorAll('[data-flix-parallax]').forEach((el) => {
      const d = parseFloat(el.getAttribute('data-depth')) || 10;
      const base = el.getAttribute('data-depth') === '10' ? 'translate(-50%,-50%) ' : '';
      el.style.transition = 'transform .25s cubic-bezier(.2,.7,.2,1)';
      el.style.transform = base + 'translate3d(' + (x * d) + 'px,' + (y * d) + 'px,0)';
    });
  }

  _onLeave() {
    this._section.querySelectorAll('[data-flix-parallax]').forEach((el) => {
      el.style.transform = el.getAttribute('data-depth') === '10' ? 'translate(-50%,-50%)' : 'translate3d(0,0,0)';
    });
  }
}
customElements.define('flix-hero', FlixHero);
